define('app/views/templates/helpers/checkIfKeyExistsInObjs',['Handlebars','underscore'], function ( Handlebars, _ ){
  function checkIfKeyExistsInObjs(objsArr, key) {
    return _.any(objsArr, function(obj) {
      return obj[key] !== undefined;
    })
  }

  Handlebars.registerHelper( 'checkIfKeyExistsInObjs', checkIfKeyExistsInObjs );
  return checkIfKeyExistsInObjs;
});
